import { translateDocumentType } from "../models/DocumentTypeEnums";

export const storeDocsColumns = (t: any) => [
    {
        key: "documentStatusStr",
        name: t('storeDocs.columns.status'),
        fieldName: "documentStatusStr",
        minWidth: 80,
        maxWidth: 120,
        isResizable: true,
    },
    {
        key: "description",
        name: t('storeDocs.columns.documentNumber'),
        fieldName: "description",
        minWidth: 150,
        maxWidth: 250,
        isResizable: true,
    },
    {
        key: "documentDate",
        name: t('storeDocs.columns.documentDate'),
        fieldName: "documentDate",
        minWidth: 80,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "documentTypeName",
        name: t('storeDocs.columns.type'),
        fieldName: "documentTypeName",
        minWidth: 80,
        maxWidth: 150,
        isResizable: true,
        onRender: (item: any) => translateDocumentType(item.documentType, item.documentTypeName, t),
    },
    {
        key: "companyName",
        name: t('storeDocs.columns.client'),
        fieldName: "companyName",
        minWidth: 250,
        maxWidth: 500,
        isResizable: true,
    },
    {
        key: "receptionPlaceName",
        name: t('storeDocs.columns.receptionPlace'),
        fieldName: "receptionPlaceName",
        minWidth: 250,
        maxWidth: 500,
        isResizable: true,
    },
    {
        key: "internalStoreName",
        name: t('storeDocs.columns.internalStore'),
        fieldName: "internalStoreName",
        minWidth: 200,
        maxWidth: 500,
        isResizable: true,
    },
    {
        key: "containersNumber",
        name: t('storeDocs.columns.containersAmount'),
        fieldName: "containersNumber",
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
    },
];